<div class="row text-left justify-content-md-center mt-5">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title" id="basic-layout-form">{{ 'account.confirmEmail.title' | translate }}</h4>
        <p class="mb-0">{{ 'account.confirmEmail.text' | translate }}</p>
      </div>
      <div class="card-body">
        <div class="px-3">
          <form class="form" #confirmEmailForm="ngForm" (ngSubmit)="onSubmit(confirmEmailForm)">
            <h4 class="form-section"><i class="ft-cpu"></i> {{ 'account.confirmEmail.detailsHeader' | translate }}</h4>
            <div class="form-group">
              <label for="Email">{{ 'account.confirmEmail.emailFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-mail"></i>
                  </span>
                </div>
                <input type="text" class="form-control" name="Email" id="Email" #Email="ngModel"
                       placeholder="{{'account.confirmEmail.emailFieldPlaceHolder' | translate}}"
                       autocomplete="email"
                       [(ngModel)]="confirmEmail.Email" required email ngModel [ngModelOptions]="{updateOn: 'blur'}"
                       pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"/>
              </div>
              <small class="form-text text-muted danger" *ngIf="!Email.valid && (Email.dirty || Email.touched)">Please
                enter a valid email!</small>
            </div>
            <div class="form-group">
              <label for="Code">{{ 'account.confirmEmail.codeFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icon-envelope-letter"></i>
                  </span>
                </div>
                <input type="text" id="Code" class="form-control" name="Code" #Code="ngModel"
                       placeholder="{{'account.confirmEmail.codeFieldPlaceHolder' | translate}}"
                       autocomplete="one-time-code"
                       [(ngModel)]="confirmEmail.Code" required>
              </div>
            </div>
            <div class="form-group">
              <label for="Password">{{ 'account.confirmEmail.passwordFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-lock"></i>
                  </span>
                </div>
                <input type="password" id="Password" class="form-control" name="Password" #Password="ngModel"
                       placeholder="{{'account.confirmEmail.passwordFieldPlaceHolder' | translate}}"
                       autocomplete="current-password"
                       [(ngModel)]="confirmEmail.Password" required/>
              </div>
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary btn-raised mr-1" [disabled]="!confirmEmailForm.valid">
                <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
